import PageDesigner from 'pages/admin/Designer';
// import LocationsPage from 'pages/admin/LocationsPage';
import HomePage from 'pages/HomePage';
import LoginPage from 'pages/LoginPage';
import PhotosPage from 'pages/PhotosPage';
import NamePage from 'pages/NamePage';
import TypePage from 'pages/TypePage';
import GuestInfoPage from 'pages/GuestInfoPage';
import DescriptionPage from 'pages/DescriptionPage';
import AmenitiesPage from 'pages/AmenitiesPage';
import { RoutePropInterface } from 'types/CommonTypes';
import LocationPage from 'pages/LocationPage';
import ListingsPage from 'pages/ListingsPage';
import SettingsPage from 'pages/SettingsPage';
import BusinessListPage from 'pages/settings/BusinessListPage';
import LanguageSettingsPage from 'pages/settings/LanguageSettingsPage';
import RegionSettingsPage from 'pages/settings/RegionSettingPage';
import CustomFieldsPage from 'pages/settings/CustomFieldsPage';
import UserManagementPage from 'pages/settings/UserManagementPage';
import PrivacySettingsPage from 'pages/settings/PrivacySettingsPage';
import TermsSettingsPage from 'pages/settings/TermsSettingsPage';
import CommonGuiedes from 'pages/CommonGuiedes';
import CheckinCheckoutPage from 'pages/admin/checkin-guide/checkin-checkout';
import CheckinMethodPage from 'pages/admin/checkin-guide/checkin-method';
import WifiInfoPage from 'pages/admin/checkin-guide/wifi-info';
import ManualPage from 'pages/admin/checkin-guide/manual';
import RulesPage from 'pages/admin/checkin-guide/rules';
import CheckoutInfoPage from 'pages/admin/checkin-guide/checkout-info';
import TagPage from 'pages/TagPage';
import NewListingPage from 'pages/NewListingPage';
import ListSettingsPage from 'pages/ListSettingsPage';
import OptionGoodsSettingPage from 'pages/settings/OptionGoodsSettingPage';
import AdditionalOptionsPage from 'pages/AdditionalOptionPage';
import LandmarkSettingPage from 'pages/settings/LandmarkSettingPage';
import ListingLandmarkSettingsPage from 'pages/ListingLandmarkSettingsPage';
import PromotionsPage from 'pages/PromotionsPage';
import TagSettingPage from 'pages/settings/TagSettingPage';
import AmenitySettingPage from 'pages/settings/AmenitySettingPage';
import ReservationDailyPage from 'components/pages/management/ReservationDailyPage';
import ReservationPeriodPage from 'components/pages/management/ReservationPeriodPage';
import VoucherPage from 'components/pages/management/VoucherPage';
import MessagePage from 'components/pages/management/MessagePage';
import PolicyPage from 'components/pages/management/PolicyPage';
import ReviewPage from 'components/pages/management/ReviewPage';
import UserPage from 'components/pages/management/UserPage';
import AdminUserPage from 'components/pages/management/AdminUserPage';
import CouponPage from 'components/pages/management/CouponPage';
import VoucherCategoryPage from 'components/pages/management/VoucherGroupPage';
import UserCouponPage from 'components/pages/management/UserCouponPage';
import RefundPage from 'components/pages/management/RefundPage';
import MemberPolicyPage from 'components/pages/management/MemberPolicyPage';
import MemberPointPage from 'components/pages/management/MemberPointPage';

const mainRoutes: RoutePropInterface[] = [
  {
    path: '/',
    name: '',
    element: ListingsPage,
    useNav: true,
  },
  {
    path: '/login',
    name: '',
    element: LoginPage,
    isPublic: true,
  },

  {
    path: '/admin',
    name: '',
    element: PageDesigner,
  },
  {
    path: '/admin/listings',
    name: '',
    element: ListingsPage,
    useNav: false,
  },
  {
    path: '/admin/listings/new',
    name: '',
    element: NewListingPage,
  },
  {
    path: '/admin/listings/:listingId',
    name: '',
    element: ListingsPage,
  },
  {
    path: '/admin/designer',
    name: '',
    element: PageDesigner,
  },
  {
    path: '/admin/locations',
    name: '',
    element: LocationPage,
  },
  {
    path: '/admin/listings/:listingId/photos',
    name: '사진',
    element: PhotosPage,
  },
  {
    path: '/admin/listings/:listingId/name',
    name: '숙소명',
    element: NamePage,
  },
  {
    path: '/admin/listings/:listingId/type',
    name: '숙소유형',
    element: TypePage,
  },
  {
    path: '/admin/listings/:listingId/guest-info',
    name: '게스트정보',
    element: GuestInfoPage,
  },
  {
    path: '/admin/listings/:listingId/description',
    name: '설명',
    element: DescriptionPage,
  },
  {
    path: '/admin/listings/:listingId/amenities',
    name: '편의시설',
    element: AmenitiesPage,
  },
  {
    path: '/admin/listings/:listingId/location',
    name: '위치',
    element: LocationPage,
  },
  {
    path: '/admin/listings/:listingId/tags',
    name: '태그',
    element: TagPage,
  },
  {
    path: '/admin/listings/:listingId/additional-options',
    name: '옵션설정',
    element: AdditionalOptionsPage,
  },
  {
    path: '/admin/listings/:listingId/landmark',
    name: '주변명소 및 추천한옥설정',
    element: ListingLandmarkSettingsPage,
  },
  {
    path: '/admin/settings',
    name: '설정',
    element: SettingsPage,
    group: 'settings',
  },
  {
    path: '/admin/settings/business-list',
    name: '사업자목록',
    element: BusinessListPage,
    group: 'settings',
  },
  {
    path: '/admin/settings/language-settings',
    name: '언어설정',
    element: LanguageSettingsPage,
    group: 'settings',
  },
  {
    path: '/admin/settings/region-settings',
    name: '지역설정',
    element: RegionSettingsPage,
    group: 'settings',
  },
  {
    path: '/admin/settings/custom-fields',
    name: '커스텀필드',
    element: CustomFieldsPage,
    group: 'settings',
  },
  {
    path: '/admin/settings/user-management',
    name: '사용자관리',
    element: UserManagementPage,
    group: 'settings',
  },
  {
    path: '/admin/listings/:listingId/settings',
    name: '설정',
    element: ListSettingsPage,
    group: 'settings',
  },
  {
    path: '/admin/checkin-guide/privacy-settings',
    name: '개인정보 설정',
    element: PrivacySettingsPage,
    group: 'settings',
  },
  {
    path: '/admin/guides/option-settings',
    name: '옵션상품설정',
    element: OptionGoodsSettingPage,
    group: 'settings',
  },
  {
    path: '/admin/guides/places-settings',
    name: '장소설정',
    element: LandmarkSettingPage,
    group: 'settings',
  },
  {
    path: '/admin/checkin-guide/terms-settings',
    name: '약관설정',
    element: TermsSettingsPage,
    group: 'settings',
  },
  {
    path: '/admin/checkin-guide',
    name: '공통 체크인가이드',
    element: CommonGuiedes,
  },
  {
    path: '/admin/guides/promotions',
    name: '프로모션 설정',
    element: PromotionsPage,
  },

  {
    path: '/admin/checkin-guide/checkin-method',
    name: '체크인 방법',
    element: CheckinMethodPage,
  },
  {
    path: '/admin/checkin-guide/wifi-info',
    name: '와이파이정보',
    element: WifiInfoPage,
  },
  {
    path: '/admin/guides/manual',
    name: '숙소매뉴얼',
    element: ManualPage,
  },
  {
    path: '/admin/guides/rules',
    name: '숙소 이용규칙',
    element: RulesPage,
  },
  {
    path: '/admin/guides/checkout-info',
    name: '체크아웃 안내',
    element: CheckoutInfoPage,
  },
  {
    path: '/admin/checkin-guide/tag-settings',
    name: '태그 설정',
    element: TagSettingPage,
    group: 'settings',
  },
  {
    path: '/admin/guides/amenities-settings',
    name: '편의시설 설정',
    element: AmenitySettingPage,
    group: 'settings',
  },
  {
    path: '/management/reservations/daily',
    name: '예약관리',
    element: ReservationDailyPage,
  },
  {
    path: '/management/reservations/period',
    name: '예약관리',
    element: ReservationPeriodPage,
  },
  {
    path: '/management/vouchers',
    name: '바우처',
    element: VoucherPage,
  },
  {
    path: '/management/vouchers/categories',
    name: '바우처 카테고리',
    element: VoucherCategoryPage,
  },
  {
    path: '/management/vouchers/list/:voucherCategoryId?',
    name: '바우처 카테고리 추가',
    element: VoucherPage,
  },
  {
    path: '/management/coupons',
    name: '쿠폰',
    element: CouponPage,
  },
  {
    path: '/management/coupons/users',
    name: '쿠폰 사용자 관리',
    element: UserCouponPage,
  },
  {
    path: '/management/messages',
    name: '메시지',
    element: MessagePage,
  },
  {
    path: '/management/policies',
    name: '정책관리',
    element: PolicyPage,
  },
  {
    path: '/management/reviews',
    name: '후기관리',
    element: ReviewPage,
  },
  {
    path: '/management/users/normal',
    name: '회원관리',
    element: UserPage,
    useNav: false,
  },
  {
    path: '/management/users/managers',
    name: '관리자관리',
    element: AdminUserPage,
    useNav: false,
  },
  {
    path: '/admin/policies/refund',
    name: '환불정책',
    element: RefundPage,
    useNav: true,
  },
  {
    path: '/admin/policies/member',
    name: '회원정책',
    element: MemberPolicyPage,
    useNav: true,
  },
  {
    path: '/admin/policies/point',
    name: '포인트 정책',
    element: MemberPointPage,
    useNav: true,
  },
];

export default mainRoutes;
